/** Đăng ký skill "AI gợi ý" theo trang bước — bubble đọc registry để mở drawer. */
import { useEffect, useRef, useSyncExternalStore } from 'react';
import type { AnyStepAdapter } from './adapters/types';

export interface AiStepSkillRegistration {
  adapters: AnyStepAdapter[];
  onApplied?: () => void;
}

let current: AiStepSkillRegistration | null = null;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((l) => l());

export function getAiStepSkill(): AiStepSkillRegistration | null {
  return current;
}

export function subscribeAiStepSkill(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Đăng ký skill khi mount trang bước; cleanup khi unmount. */
export function registerAiStepSkill(reg: AiStepSkillRegistration | null) {
  current = reg && reg.adapters.length ? reg : null;
  emit();
  return () => {
    if (current === reg) {
      current = null;
      emit();
    }
  };
}

export function useAiStepSkill(): AiStepSkillRegistration | null {
  return useSyncExternalStore(subscribeAiStepSkill, getAiStepSkill, () => null);
}

export function useRegisterAiStepSkill(adapters: AnyStepAdapter[], onApplied?: () => void) {
  const onAppliedRef = useRef(onApplied);
  onAppliedRef.current = onApplied;
  const keys = adapters.map((a) => a.key).join('|');

  useEffect(() => {
    if (!adapters.length) return undefined;
    return registerAiStepSkill({
      adapters,
      onApplied: () => onAppliedRef.current?.(),
    });
    // adapters identity ổn định theo keys (module-level arrays trên các trang bước)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keys]);
}
